module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('files-panel', {
    attrs: {
      "title": "Site Attachments",
      "id": _vm.rowData.id,
      "type": "site",
      "read-only": _vm.readOnly
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3651bbed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/SiteAttachments.vue
// module id = 1498
// module chunks = 0